import { Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import type { ExpertTrialBalanceColumnDef } from '../../../../hooks/useExpertTrialBalanceColumns'
import type { ExpertTrialBalanceCell } from '../../../../types/expertTrialBalanceView'
import { TrialBalanceAmount } from '../TrialBalanceAmount'

interface TotalsRowProps {
  columns: ExpertTrialBalanceColumnDef[]
  totals: ExpertTrialBalanceCell[] | null
}

export const TotalsRow = ({ columns, totals }: TotalsRowProps): ReactElement => {
  const currentPeriod = totals?.[0]
  const previousPeriod = totals?.[1]

  const renderAmountCell = (value?: number, bold = true): ReactElement => (
    <TrialBalanceAmount bold={bold} value={value} />
  )

  const renderColumnCell = (column: ExpertTrialBalanceColumnDef): ReactElement | null => {
    switch (column.id) {
      case 'accountNumber':
      case 'label':
        return null
      case 'credit':
        return renderAmountCell(currentPeriod?.credit)
      case 'debit':
        return renderAmountCell(currentPeriod?.debit)
      case 'balance':
        return renderAmountCell(currentPeriod?.closingBalance)
      case 'balancePrevious':
        return renderAmountCell(previousPeriod?.closingBalance)
      default: {
        const exhaustiveCheck: never = column.id

        return exhaustiveCheck
      }
    }
  }

  return (
    <Table.Row highlighted>
      {columns.map((column) => (
        <Table.Cell align={column.align} highlighted={column.highlighted} key={column.id}>
          {renderColumnCell(column)}
        </Table.Cell>
      ))}
    </Table.Row>
  )
}
